import React, { useState, useEffect, useRef } from 'react';
import { isEmpty } from 'ramda';
import PropTypes from 'prop-types';

const SqueezeAudio = ({ audioSrc, isPlaying, isMuted }) => {
  const [, setAudioDuration] = useState(0);
  const [, setAudioTime] = useState(0);

  const audioRef = useRef(null);
  const audio = audioRef.current || {};

  useEffect(() => {
    const audioInstance = audioRef.current || {};

    const handleTimeUpdate = () => setAudioTime(audioInstance.currentTime);
    const handleLoadedMetadata = () => setAudioDuration(audioInstance.duration);

    audioInstance.addEventListener('timeupdate', handleTimeUpdate);
    audioInstance.addEventListener('loadedmetadata', handleLoadedMetadata);

    return () => {
      audioInstance.removeEventListener('timeupdate', handleTimeUpdate);
      audioInstance.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(audio)) {
      if (isPlaying) {
        audio.play();
      } else {
        audio.pause();
      }
    }
  }, [isPlaying]);

  return (
    <audio ref={audioRef} preload="auto" autoPlay muted={isMuted} controls={false} src={audioSrc}>
      <track kind="captions" />
      Your browser does not support the
      <code>audio</code> element.
    </audio>
  );
};

SqueezeAudio.propTypes = {
  audioSrc: PropTypes.string.isRequired,
  isPlaying: PropTypes.bool.isRequired,
  isMuted: PropTypes.bool.isRequired,
};

export default SqueezeAudio;
